export const IS_MOBILE_OS =
  /(Windows Phone)/gi.test(navigator.userAgent) ||
  /(Blackberry)/g.test(navigator.userAgent) ||
  /(Android)/g.test(navigator.userAgent) ||
  /(iPad|iPhone|iPod)/g.test(navigator.userAgent);

export const IS_MOBILE_SIZE = screen.width < 1024 && screen.height < 1024;

export const IS_MOBILE = IS_MOBILE_OS && IS_MOBILE_SIZE;
